var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 9.58266L9.16634 11.2493L12.9163 7.49932M16.6663 9.99932C16.6663 14.0897 12.2047 17.0647 10.5813 18.0117C10.3968 18.1194 10.3046 18.1732 10.1744 18.2011C10.0734 18.2228 9.92597 18.2228 9.82494 18.2011C9.69475 18.1732 9.60251 18.1194 9.41802 18.0117C7.79464 17.0647 3.33301 14.0897 3.33301 9.99932V6.01399C3.33301 5.34773 3.33301 5.0146 3.44197 4.72824C3.53824 4.47527 3.69466 4.24955 3.89772 4.0706C4.12759 3.86802 4.43951 3.75105 5.06334 3.51711L9.53151 1.84155C9.70476 1.77658 9.79138 1.7441 9.88049 1.73122C9.95954 1.7198 10.0398 1.7198 10.1189 1.73122C10.208 1.7441 10.2946 1.77658 10.4678 1.84155L14.936 3.51711C15.5598 3.75105 15.8718 3.86802 16.1016 4.0706C16.3047 4.24955 16.4611 4.47527 16.5574 4.72824C16.6663 5.0146 16.6663 5.34773 16.6663 6.01399V9.99932Z",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.68157cd02ddfaacbd517b6208a5d362e.svg";
export { ForwardRef as ReactComponent };